export default __webpack_public_path__ + "static/media/cretae-course-enabled.1b9cda16.svg";